export default "__VITE_ASSET__7c8bfd94__"